import { Type, Static } from '@sinclair/typebox';
import {
  defineSchema,
  SystemFields,
  StringField,
  TimestampField,
  BooleanField,
} from '@ayocore/platform/common/helpers/schema-types';

import { name as moduleName } from '../module.json';
/**
 * Contact Person Schema - Individual contacts within partner organizations
 *
 * Based on contact_person.json data structure.
 * Represents individual people we communicate with at partner companies.
 * Has many-to-many relationship with partners via junction table.
 */

// Complete schema (with system fields)
export const ContactPersonSchema = Type.Object({
  ...SystemFields, // Platform-provided system fields (id, created_at, updated_at)

  name: StringField({
    title: 'Имя контакта',
    minLength: 1,
    maxLength: 255,
    description: 'Полное имя контактного лица',
  }),

  position: StringField({
    title: 'Должность',
    nullable: true,
    maxLength: 255,
    description: 'Должность/позиция в компании',
  }),

  birthday: TimestampField({
    title: 'День рождения',
    nullable: true,
    description: 'День рождения контактного лица',
  }),

  notes: StringField({
    title: 'Примечания',
    nullable: true,
    maxLength: 1000,
    description: 'Внутренние заметки о контактном лице',
  }),

  is_decision_maker: BooleanField({
    title: 'Лицо, принимающее решения',
    default: false,
    description: 'Признак лица, принимающего решения (ЛПР)',
  }),
});

// TypeScript types derived from schemas
export type ContactPerson = Static<typeof ContactPersonSchema>;

// Schema definition with automatic table prefixing
export default defineSchema({
  moduleName,
  tableName: 'contact_persons', // System will prefix with 'crm_'
  schema: ContactPersonSchema,
  additionalIndexes: ['name'],
});
